<template>
  <div id="cart">
    <div class="cart-left">
      <div class="row">
        <div class="col">
          <a href="/" class="back-to-shopping">&lt; Back to shopping</a>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
      <div class="row">
        <div class="col">
          <div class="shipping-well">
            <!-- ==================== Cart Progress ==================== -->
            <div class="cart-progress">
              <div class="row">
                <div class="col">
                  <h6
                    class="progress-title"
                    v-if="this.distanceToFreeShipping() / 100 === 0"
                  >
                    You qualify for free shipping!
                  </h6>
                  <h6 class="progress-title" v-else>
                    Spend
                    <span>{{
                      filterPrice(this.distanceToFreeShipping() / 100)
                    }}</span>
                    more to qualify for free shipping
                  </h6>
                  <div
                    class="progress"
                    role="progressbar"
                    aria-label="Basic example"
                    v-bind:aria-valuenow="
                      100 - this.distanceToFreeShipping() / 100
                    "
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      class="progress-bar"
                      :style="`width: ${
                        100 - this.distanceToFreeShipping() / 100
                      }%;`"
                    ></div>
                  </div>
                </div>
                <!-- .col -->
              </div>
              <!-- .row -->
            </div>
            <!-- .cart-progress -->
          </div>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->

      <hr />
      <div class="row">
        <div class="col">
          <div class="stuff-in-cart" v-if="cart.items.length !== 0">
            <div class="cart-contents">
              <div
                class="cart-prod"
                v-for="item in cart.items"
                :key="item.id"
                :data-id="item.id"
              >
                <div class="cart-prod-row">
                  <div class="cart-prod-img">
                    <img
                      class="img-fluid"
                      v-if="item.properties?._imgUrl"
                      v-bind:src="item.properties._imgUrl"
                      :alt="item.featured_image.alt"
                    />
                    <img
                      class="img-fluid"
                      v-else
                      v-bind:src="item.featured_image.url"
                      :alt="item.featured_image.alt"
                    />
                  </div>
                  <!-- .cart-prod-img -->
                  <div class="cart-prod-deets">
                    <div class="row">
                      <div class="col-8">
                        <h6>{{ item.product_title }}</h6>
                        <p>{{ item.variant_title }}</p>
                        <div class="qty">
                          <button
                            class="down"
                            v-on:click="updateItem(item.key, item.quantity - 1)"
                          >
                            -
                          </button>
                          <input
                            type="text"
                            class="value"
                            v-bind:value="item.quantity"
                          />
                          <button
                            class="up"
                            :class="{ disabled: isChoiceItem(item) }"
                            v-on:click="updateItem(item.key, item.quantity + 1)"
                            :disabled="isChoiceItem(item)"
                          >
                            +
                          </button>
                        </div>
                        <!-- <p>{{ }}</p> -->
                      </div>
                      <!-- .col -->
                      <div class="col-4 text-right">
                        <h6
                          v-if="item.line_level_discount_allocations.length > 0"
                          class="original-price"
                        >
                          {{ filterPrice(item.original_line_price / 100) }}
                        </h6>
                        <h6>
                          {{ filterPrice(item.final_line_price / 100) }}
                        </h6>
                        <div
                          class="discount-message"
                          v-for="discount in item.line_level_discount_allocations"
                        >
                          <p>
                            {{ discount.discount_application.title }}
                          </p>
                        </div>
                      </div>
                      <!-- .col -->
                    </div>
                    <!-- .row -->
                    <div class="row d-flex align-items-center">
                      <div class="col-8">
                        <div
                          class="pickup-unavailable"
                          v-if="
                            !selectedLocationHasInventoryForVariantId(item.id)
                          "
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.8978 8.89L20.8478 4.52C20.6278 3.62 19.8478 3 18.9378 3H5.04781C4.14781 3 3.35781 3.63 3.14781 4.52L2.09781 8.89C1.85781 9.91 2.07781 10.95 2.71781 11.77C2.79781 11.88 2.90781 11.96 2.99781 12.06V19C2.99781 20.1 3.89781 21 4.99781 21H18.9978C20.0978 21 20.9978 20.1 20.9978 19V12.06C21.0878 11.97 21.1978 11.88 21.2778 11.78C21.9178 10.96 22.1478 9.91 21.8978 8.89ZM18.9078 4.99L19.9578 9.36C20.0578 9.78 19.9678 10.2 19.7078 10.53C19.5678 10.71 19.2678 11 18.7678 11C18.1578 11 17.6278 10.51 17.5578 9.86L16.9778 5L18.9078 4.99ZM12.9978 5H14.9578L15.4978 9.52C15.5478 9.91 15.4278 10.3 15.1678 10.59C14.9478 10.85 14.6278 11 14.2178 11C13.5478 11 12.9978 10.41 12.9978 9.69V5ZM8.48781 9.52L9.03781 5H10.9978V9.69C10.9978 10.41 10.4478 11 9.70781 11C9.36781 11 9.05781 10.85 8.81781 10.59C8.56781 10.3 8.44781 9.91 8.48781 9.52ZM4.03781 9.36L5.04781 5H7.01781L6.43781 9.86C6.35781 10.51 5.83781 11 5.22781 11C4.73781 11 4.42781 10.71 4.29781 10.53C4.02781 10.21 3.93781 9.78 4.03781 9.36ZM4.99781 19V12.97C5.07781 12.98 5.14781 13 5.22781 13C6.09781 13 6.88781 12.64 7.46781 12.05C8.06781 12.65 8.86781 13 9.77781 13C10.6478 13 11.4278 12.64 12.0078 12.07C12.5978 12.64 13.3978 13 14.2978 13C15.1378 13 15.9378 12.65 16.5378 12.05C17.1178 12.64 17.9078 13 18.7778 13C18.8578 13 18.9278 12.98 19.0078 12.97V19H4.99781Z"
                              fill="#ee562b"
                            />
                          </svg>
                          <span class="bold">Pick Up</span
                          ><span>Unavailable</span>
                        </div>
                      </div>
                      <!-- .col -->
                      <div class="col-4 text-right">
                        <button
                          class="trash"
                          v-on:click="updateItem(item.key, 0)"
                        >
                          <span class="lid"></span>
                          <span class="can"></span>
                        </button>
                      </div>
                      <!-- .col -->
                    </div>
                    <!-- .row -->
                  </div>
                  <!-- .cart-prod-deets -->
                </div>
                <!-- .cart-prod-row -->
              </div>
              <!-- .cart-prod -->
            </div>
            <!-- .cart-contents -->
          </div>
          <div v-else>
            <div class="row">
              <div
                class="col text-center"
                style="margin-bottom: 10px; margin-top: 10px"
              >
                <h5>Your cart is empty</h5>
              </div>
            </div>
            <!-- .row -->
          </div>
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
      <div class="row">
        <div class="col">
          <div class="message-well">
            <svg
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.625 0H6.375V1.41667H10.625V0ZM7.79167 9.20833H9.20833V4.95833H7.79167V9.20833ZM13.4796 4.52625L14.4854 3.52042C14.1808 3.15917 13.8479 2.81917 13.4867 2.52167L12.4808 3.5275C11.3829 2.64917 10.0017 2.125 8.5 2.125C4.97958 2.125 2.125 4.97958 2.125 8.5C2.125 12.0204 4.9725 14.875 8.5 14.875C12.0275 14.875 14.875 12.0204 14.875 8.5C14.875 6.99833 14.3508 5.61708 13.4796 4.52625ZM8.5 13.4583C5.75875 13.4583 3.54167 11.2413 3.54167 8.5C3.54167 5.75875 5.75875 3.54167 8.5 3.54167C11.2413 3.54167 13.4583 5.75875 13.4583 8.5C13.4583 11.2413 11.2413 13.4583 8.5 13.4583Z"
                fill="black"
              />
            </svg>
            <span
              >Items in your cart are not reserved, checkout soon to get your
              gear!</span
            >
          </div>
          <!-- .message-well -->
        </div>
        <!-- .col -->
      </div>
      <!-- .row -->
      <!-- hide BOPIS until we get an update from shopify -->
      <div class="button-row" v-if="false">
        <a
          href="#"
          class="btn btn-default"
          :class="[isPickUpSelected === false ? 'active' : '']"
          v-on:click="setPickupOption(false)"
          ><svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.5 8H17.5V4H3.5C2.4 4 1.5 4.9 1.5 6V17H3.5C3.5 18.66 4.84 20 6.5 20C8.16 20 9.5 18.66 9.5 17H15.5C15.5 18.66 16.84 20 18.5 20C20.16 20 21.5 18.66 21.5 17H23.5V12L20.5 8ZM20 9.5L21.96 12H17.5V9.5H20ZM6.5 18C5.95 18 5.5 17.55 5.5 17C5.5 16.45 5.95 16 6.5 16C7.05 16 7.5 16.45 7.5 17C7.5 17.55 7.05 18 6.5 18ZM8.72 15C8.17 14.39 7.39 14 6.5 14C5.61 14 4.83 14.39 4.28 15H3.5V6H15.5V15H8.72ZM18.5 18C17.95 18 17.5 17.55 17.5 17C17.5 16.45 17.95 16 18.5 16C19.05 16 19.5 16.45 19.5 17C19.5 17.55 19.05 18 18.5 18Z"
              fill="#25282a"
            />
          </svg>
          <span class="bold">Ship It</span
          ><span>Calculated at Checkout</span></a
        >
        <a
          href="#"
          class="btn btn-default"
          :class="[isPickUpSelected === true ? 'active' : '']"
          v-on:click="setPickupOption(true)"
          ><svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.8978 8.89L20.8478 4.52C20.6278 3.62 19.8478 3 18.9378 3H5.04781C4.14781 3 3.35781 3.63 3.14781 4.52L2.09781 8.89C1.85781 9.91 2.07781 10.95 2.71781 11.77C2.79781 11.88 2.90781 11.96 2.99781 12.06V19C2.99781 20.1 3.89781 21 4.99781 21H18.9978C20.0978 21 20.9978 20.1 20.9978 19V12.06C21.0878 11.97 21.1978 11.88 21.2778 11.78C21.9178 10.96 22.1478 9.91 21.8978 8.89ZM18.9078 4.99L19.9578 9.36C20.0578 9.78 19.9678 10.2 19.7078 10.53C19.5678 10.71 19.2678 11 18.7678 11C18.1578 11 17.6278 10.51 17.5578 9.86L16.9778 5L18.9078 4.99ZM12.9978 5H14.9578L15.4978 9.52C15.5478 9.91 15.4278 10.3 15.1678 10.59C14.9478 10.85 14.6278 11 14.2178 11C13.5478 11 12.9978 10.41 12.9978 9.69V5ZM8.48781 9.52L9.03781 5H10.9978V9.69C10.9978 10.41 10.4478 11 9.70781 11C9.36781 11 9.05781 10.85 8.81781 10.59C8.56781 10.3 8.44781 9.91 8.48781 9.52ZM4.03781 9.36L5.04781 5H7.01781L6.43781 9.86C6.35781 10.51 5.83781 11 5.22781 11C4.73781 11 4.42781 10.71 4.29781 10.53C4.02781 10.21 3.93781 9.78 4.03781 9.36ZM4.99781 19V12.97C5.07781 12.98 5.14781 13 5.22781 13C6.09781 13 6.88781 12.64 7.46781 12.05C8.06781 12.65 8.86781 13 9.77781 13C10.6478 13 11.4278 12.64 12.0078 12.07C12.5978 12.64 13.3978 13 14.2978 13C15.1378 13 15.9378 12.65 16.5378 12.05C17.1178 12.64 17.9078 13 18.7778 13C18.8578 13 18.9278 12.98 19.0078 12.97V19H4.99781Z"
              fill="#25282a"
            />
          </svg>
          <span class="bold">Pick Up</span><span>As soon as today!</span></a
        >
      </div>
      <div class="row" v-if="isPickUpSelected" style="margin-top: 30px">
        <div class="col">
          <h5>Find the nearest store for pickup</h5>
          <div class="row g-2">
            <div class="col-sm-5">
              <input
                type="text"
                name="location"
                class="pickup-form"
                placeholder="Zip, City or State..."
                v-model="addressInput"
                @input="getPredictionsWithDebounce"
              />
            </div>
            <!-- .col -->
            <div class="col-sm-3">
              <select
                v-model="distanceSelector"
                name="distance"
                class="pickup-form"
              >
                <option value="" disabled selected>Distance</option>
                <option value="10">10 Miles</option>
                <option value="30">30 Miles</option>
                <option value="50">50 Miles</option>
              </select>
            </div>
            <!-- .col -->
            <div class="col-sm-4">
              <a class="btn btn-black btn-block" v-on:click="findStores()"
                >Find Stores</a
              >
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
          <div
            v-for="prediction in placesQueryPredictions"
            v-if="!hideLocationPredictions"
          >
            <div v-on:click="predictionClicked(prediction)">
              {{ prediction.description }}
            </div>
          </div>

          <div class="disclaimers">
            <p>
              <small class=""
                >Product availability may vary from recent store
                inventory.</small
              >
            </p>
            <h5 class="warning" v-if="showMissingInventoryWarning()">
              Some of the items in your cart are not available for pick up.
            </h5>
            <h6 class="warning" v-if="showMissingInventoryWarning()">
              Try another search, edit your cart - OR - we can ship the whole
              order to you!
            </h6>
          </div>
          <!-- .disclaimers -->
        </div>
        <!-- .col-12 -->
      </div>
      <!-- .button-row -->

      <div
        class="store-list"
        v-if="
          fitleredLocations.length > 0 &&
          isPickUpSelected &&
          userLocation.hasSearchedForStores
        "
      >
        <h6>Available in {{ fitleredLocations.length }} Location</h6>
        <hr />
        <div
          class="row gx-3"
          v-for="location in fitleredLocations"
          :key="location.id"
          :data-id="location.id"
          v-on:click="getSelectedLocationInventory(location)"
        >
          <div class="col-auto">
            <input
              type="checkbox"
              class="form-check-input"
              :id="location.name"
              :name="location.name"
              v-model="location.isSelected"
            />
          </div>
          <!-- .col-1 -->
          <div class="col-6">
            <div class="store-name">
              <span>{{ location.name }}</span> |
              {{
                calculateDistance(
                  userLocation.lat,
                  userLocation.lon,
                  location.lat,
                  location.lon
                )
              }}
              miles away
            </div>
            <div class="bopis">Buy online pickup in store</div>
            <p>
              {{ location.address1 }} {{ location.address2 }}<br />
              {{ location.city }}, {{ location.province }} {{ location.zip }}
            </p>
          </div>
          <!-- .col-6 -->
          <div class="col-5" v-if="location.isPickupLocation">
            <p>
              Store Hours: <br />
              <span v-for="hours in location.hours">{{ hours }} <br /></span>
            </p>
          </div>
          <!-- .col-5 -->
        </div>
        <!-- .row -->
      </div>
      <!-- if no pickup locations are in range -->
      <div
        v-else-if="
          fitleredLocations.length === 0 &&
          isPickUpSelected &&
          userLocation.hasSearchedForStores
        "
      >
        <div class="oops">
          <h5>There aren't any pickup location in range.</h5>
          <h6>Try adjusting your search, or select delivery.</h6>
        </div>
      </div>
    </div>
    <!-- cart-left -->
    <div class="cart-right">
      <div class="row">
        <div class="col-12">
          <h4>Order Summary</h4>
        </div>
        <!-- .col-12 -->
      </div>
      <!-- .row -->
      <div class="summary">
        <hr />
        <div class="row mb-3">
          <div class="col-6">
            <div class="summary-item">Subtotal</div>
          </div>
          <!-- .col-6 -->
          <div class="col-6">
            <div class="summary-price">
              {{ filterPrice(cart.total_price / 100) }}
            </div>
          </div>
          <!-- .col-6 -->
        </div>
        <!-- .row -->
        <div class="row">
          <div class="col-6">
            <div class="summary-item">Shipping</div>
          </div>
          <!-- .col-6 -->
          <div class="col-6">
            <div class="summary-price free-shipping">
              Calculated At Checkout
            </div>
          </div>
          <!-- .col-6 -->
        </div>
        <!-- .row -->
        <hr />
        <div class="row">
          <div class="col-6">
            <div class="summary-item">Total</div>
          </div>
          <!-- .col-6 -->
          <div class="col-6">
            <div class="summary-total-price">
              <span>USD</span>{{ filterPrice(cart.total_price / 100) }}
            </div>
          </div>
          <!-- .col-6 -->
        </div>
        <!-- .row -->
      </div>
      <!-- .summary -->
      <!-- ==================== Donation Checkbox ==================== -->
      <div class="cart-checkbox donate-wrapper">
        <div class="form-check form-switch">
          <div class="form-check-img" @click="$refs.modalDonate.openModal()">
            <img
              src="https://res.cloudinary.com/cotopaxi/image/upload/v1688747712/do-good-cart_rju2t5.png"
              class="img-fluid"
              alt="Do Good"
            />
          </div>
          <div class="form-check-label">
            <label for="flexCheckIndeterminate"
              >Donate today and help end extreme poverty in our lifetime.</label
            >
            <a class="superscript_link" @click="$refs.modalDonate.openModal()"
              >See Details</a
            >
          </div>
          <!-- .form-check-label -->
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            :checked="cartContainsDonationCheckboxItem()"
            id="flexCheckIndeterminate"
            v-on:click="updateItem(40511363612733, 1)"
          />
        </div>
        <!-- .form-check -->
      </div>
      <!-- .cart-checkbox -->
      <!-- ==================== Route Checkbox ==================== -->
      <div
        class="cart-checkbox route-wrapper"
        v-if="cartContainsShippableItem()"
      >
        <div class="form-check form-switch">
          <div class="form-check-img">
            <img
              src="https://cdn.shopify.com/s/files/1/0281/7544/files/Route_logo.PNG?37005"
              class="route-modal-trigger lazy-cart"
              alt="Route Logo"
              style="height: auto; width: 40px"
            />
          </div>
          <!-- .form-check-img -->
          <div class="form-check-label">
            <label for="route_checkbox"
              >Add Route shipping protection for $1.15.</label
            >
            <a
              class="superscript_link route-modal-trigger"
              @click="$refs.modalRoute.openModal()"
              >See Details
            </a>
          </div>
          <!-- .form-check-label -->
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            :checked="cartContainsRouteInsuranceItem()"
            id="route_checkbox"
            v-on:click="updateItem(39947795988541, 1)"
          />
        </div>
        <!-- .form-check -->
      </div>
      <!-- klarna placement -->
      <div class="klarna-container">
        <klarna-placement
          data-key="credit-promotion-badge"
          data-locale="en-US"
          :data-purchase-amount="cart.total_price"
        ></klarna-placement>
      </div>
      <!-- .cart-checkbox -->
      <div class="checkout-buttons hidden-mobile">
        <a href="/checkout" class="btn btn-black btn-block btn-lg"
          >Continue to Checkout</a
        >
      </div>
      <!-- checkout-buttons -->
      <div class="additional-buttons hidden-mobile" v-if="false">
        <a href="#" class="btn btn-black">butt</a>
        <a href="#" class="btn btn-black">on</a>
        <a href="#" class="btn btn-black">click</a>
      </div>
      <!-- additional-buttons -->
      <!-- ==================== Guaranteed for Good Box ==================== -->
      <div class="guaranteed-for-good-box hidden-mobile">
        <div class="row">
          <div class="col-4">
            <img
              src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/guaranteed-for-good-logo.png?v=31469726860796051801655495265"
              loading="lazy"
              alt="Guaranteed for Good™"
              class="img-responsive"
            />
          </div>
          <!-- .col -->
          <div class="col-8">
            <h4>Guaranteed for Good™</h4>
            <div class="row icon-row">
              <div class="col-12">
                <img
                  class="img-icon g4g-icon"
                  src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Free-Returns-Exchanges.svg"
                  loading="lazy"
                />
                <span>Easy Returns &amp; Exchanges</span>
              </div>
              <!-- .col-12 -->
              <div class="col-12">
                <img
                  class="img-icon g4g-icon"
                  src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-Lifetime-Warranty.svg"
                  loading="lazy"
                />
                <span>Lifetime Warranty + Repairs</span>
              </div>
              <!-- .col-12 -->
              <!-- pre-loved gear logo -->
              <div class="col-12">
                <img
                  class="img-icon g4g-icon"
                  src="https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets/Icon-RePurposed.svg"
                  loading="lazy"
                />
                <span>Trade-In for Gift Cards</span>
              </div>
              <!-- .col-12 -->
            </div>
            <!-- .row -->
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <!-- .guaranteed-for-good-box -->
    </div>
    <!-- cart-right -->
    <div class="cart-footer-mobile">
      <div class="checkout-buttons">
        <a href="/checkout" class="btn btn-black btn-block btn-lg"
          >Continue to Checkout</a
        >
      </div>
      <!-- checkout-buttons -->
      <div class="additional-buttons" v-if="false">
        <a href="#" class="btn btn-black">butt</a>
        <a href="#" class="btn btn-black">on</a>
        <a href="#" class="btn btn-black">click</a>
      </div>
      <!-- additional-buttons -->
    </div>
  </div>
</template>

<script src="./ctrl-cart.js">
// import PdpErr from './pdp-error/pdp-err.vue';
</script>
